module.exports = __webpack_public_path__ + "static/media/pheasant_specification_en.802c4d06.md";